import PayrollConceptsView  from "../PayrollConceptsView.vue";
import PayrollConceptList   from "../Pages/PayrollConceptList.vue";
import PayrollConceptEditor from "../Pages/PayrollConceptEditor.vue";

const routes = [
  {
    path: "/mantenimiento/conceptos",
    component: PayrollConceptsView,
    children: [
      {
        path: "",
        name: "payroll-concept-list",
        component: PayrollConceptList,
      },
      {
        path: "crear",
        name: "payroll-concept-create",
        component: PayrollConceptEditor,
      },
      {
        path: ":id/editar",
        name: "payroll-concept-edit",
        component: PayrollConceptEditor,
      },
    ],
  },
];

export default routes;
